import Axios from 'axios';
 
const CUSTOMER = '/customer';
const CUSTOMER_COVERAGE='/customer_coverage'
 
export default {
  getAll() {
    return Axios.get(CUSTOMER);
  },
 
  get(id) {
    return Axios.get(`${CUSTOMER}/${id}`);
  },
 
  create(data) {
    return Axios.post(CUSTOMER, data);
  },
 
  update(id, data) {
    return Axios.put(`${CUSTOMER}/${id}`, data);
  },
 
  delete(id) {
    return Axios.delete(`${CUSTOMER}/${id}`);
  },


  //Customer coverage
  getCustomerCoverage(customer_id){
    return Axios.get(`${CUSTOMER_COVERAGE}/getByCustomer/${customer_id}`);
  },

  createCustomerCoverage(data) {
    return Axios.post(CUSTOMER_COVERAGE, data);
  },

  updateCustomerCoverage(id,data){
    return Axios.put(`${CUSTOMER_COVERAGE}/${id}`, data);
  },

  deleteCustomerCoverage(id,data){
    return Axios.delete(`${CUSTOMER_COVERAGE}/${id}`, data);
  }


};